/* eslint-disable max-depth */
import { Tree, Modal, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux';
import { soilSearchGetAdministrativeArea } from '@/util/Request';
import { GetPropertyListResponseModel, ISoilSearchAdministrativeAreaResModel } from '@/util/Request/requestType';
import './index.less';
import SoilSearchProperties from '@/components/SoilSearchProperties';
import {
    SoilProfileDropDownIcon,
    SoilProfileExpandIcon,
    SoilProfileWarningAlertIcon,
    SoilSearchClearIcon
} from '@/resource/IconComponentSets';
import { updateFromQueryHistory, updateThirdTabValues } from '@/redux/reducer/soilSerach';

const { confirm } = Modal;

interface ITreeSingleMode {
    title: string
    key: string
    item: ISoilSearchAdministrativeAreaResModel
    children: ITreeSingleMode[]
    icon: React.ReactNode
}

interface IProps {
    isSplitByCountry: boolean
    executeButtonClick: () => void
    saveQueryButtonClick?: () => void
}

const AdminAreaComponent = (props: IProps) => {
    const {
        executeButtonClick,
        saveQueryButtonClick
    } = props;

    const dispatch = useDispatch();

    const {
        areaIds,
        adminiTabPropertySet,
        soilPropertyList,
        checkedKeys,
        expandedKeys,
        fromQueryHistory
    } = useSelector((state: RootState) => state.soilSearchPageData);

    // SECTION: state declaration area
    const [treeData, setTreeData] = useState<ITreeSingleMode[]>([]);
    const [originalData, setOiriginalData] = useState<ITreeSingleMode[]>([]);
    const [selectedProperty, setSelectedProperty] = useState<GetPropertyListResponseModel>();
    const [haveBeenRequestAreaIds, setHaveBeenRequestAreaIds] = useState<string[]>([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        requestForTopAreasInfo();
    }, []);

    useEffect(() => {
        if (fromQueryHistory && treeData.length > 0) {
            handleBackTreeData();
            dispatch(updateFromQueryHistory(false));
        }
    }, [treeData]);

    // SECTION: network include function
    const requestForTopAreasInfo = async () => {
        try {
            const res = await soilSearchGetAdministrativeArea('', true);
            const topLevelArea = res.map((area) => {
                return {
                    title: area.area_Name,
                    key: area.area_ID,
                    item: area,
                    children: [],
                    icon: <SoilProfileDropDownIcon />
                };
            });
            setTreeData(topLevelArea);
            const newTopLeveldata = JSON.parse(JSON.stringify(topLevelArea));
            setOiriginalData(newTopLeveldata);
            return topLevelArea;
        } catch (err) {
            console.log('err:==', err);
        }
    };

    const requestForNormalAreaInfo = async (areaId: string, localExpandKeys: string[]) => {
        try {
            if (isFetching) return;
            setIsFetching(true);
            const keyArr = areaId.split('-');
            const requestAreaId = keyArr[keyArr.length - 1];
            const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
            const administrativeArea = handleAreaFormat(res, areaId);
            for (const state of treeData) {
                const stateKey = keyArr[0];
                if (stateKey && stateKey === state.key) {
                    const stateItem = state;
                    // if next children was null, define current children to current item
                    if (!keyArr[1]) {
                        stateItem.children = administrativeArea;
                        const include = localExpandKeys.includes(keyArr[0]);
                        include ? stateItem.icon = <SoilProfileExpandIcon /> : stateItem.icon = <SoilProfileDropDownIcon />;
                        break;
                    }
                    const provinceKey = `${keyArr[0]}-${keyArr[1]}`;
                    for (const provinceItem of stateItem.children) {
                        if (provinceItem.key === provinceKey) {
                            const targetProvinceItem = provinceItem;
                            if (!keyArr[2]) {
                                targetProvinceItem.children = administrativeArea;
                                if (provinceItem.item.area_IfHasChildLevel) {
                                    const include = localExpandKeys.includes(provinceKey);
                                    include ? targetProvinceItem.icon = <SoilProfileExpandIcon /> : targetProvinceItem.icon = <SoilProfileDropDownIcon />;
                                } else {
                                    targetProvinceItem.icon = null;
                                }
                                break;
                            }
                            const cityKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}`;
                            for (const cityItem of targetProvinceItem.children) {
                                if (cityItem.key === cityKey) {
                                    const targetCityItem = cityItem;
                                    if (!keyArr[3]) {
                                        if (targetCityItem.item.area_IfHasChildLevel) {
                                            const include = localExpandKeys.includes(cityKey);
                                            include ? targetCityItem.icon = <SoilProfileExpandIcon /> : targetCityItem.icon = <SoilProfileDropDownIcon />;
                                        } else {
                                            targetCityItem.icon = null;
                                        }
                                        targetCityItem.children = administrativeArea;
                                        break;
                                    }
                                    const districtKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}`;
                                    for (const district of targetCityItem.children) {
                                        if (district.key === districtKey) {
                                            const targetDistrictItem = district;
                                            if (!keyArr[4]) {
                                                if (targetDistrictItem.item.area_IfHasChildLevel) {
                                                    const include = localExpandKeys.includes(districtKey);
                                                    include ? targetDistrictItem.icon = <SoilProfileExpandIcon /> : targetDistrictItem.icon = <SoilProfileDropDownIcon />;
                                                } else {
                                                    targetCityItem.icon = null;
                                                }
                                                targetDistrictItem.children = administrativeArea;
                                                break;
                                            }
                                            const countyKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}`;
                                            for (const countyItem of targetDistrictItem.children) {
                                                if (countyItem.key === countyKey) {
                                                    const targetCountyItem = countyItem;
                                                    if (!keyArr[5]) {
                                                        if (targetCountyItem.item.area_IfHasChildLevel) {
                                                            const include = localExpandKeys.includes(countyKey);
                                                            include ? targetCountyItem.icon = <SoilProfileExpandIcon /> : targetCountyItem.icon = <SoilProfileDropDownIcon />;
                                                        } else {
                                                            targetCityItem.icon = null;
                                                        }
                                                        targetCountyItem.children = administrativeArea;
                                                        break;
                                                    }
                                                    const touwnKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}-${keyArr[5]}`;
                                                    for (const town of targetCountyItem.children) {
                                                        if (town.key === touwnKey){
                                                            const targetTown = town;
                                                            targetTown.children = administrativeArea;
                                                            targetTown.icon = null;
                                                            break;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setTreeData([...treeData]);
            const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
            newHaveBeenRequestAreaIds.push(areaId);
            setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
            setIsFetching(false);
        } catch (err) {
            setIsFetching(false);
        }
    };

    const treeDataRef = useRef([]);
    const expandedKeysRef = useRef([]);
    const checkedKeysRef = useRef([]);
    const requestForNormalAreaInfoForWriteBack = async (areaIds: string[], localExpandKeys: string[]) => {
        try {
            if (isFetching) return;
            setIsFetching(true);
            const topArea = await requestForTopAreasInfo();
            treeDataRef.current = topArea;
            expandedKeysRef.current = [...expandedKeys];
            checkedKeysRef.current = [...checkedKeys];
            dispatch(updateThirdTabValues({
                expandedKeys: [],
                checkedKeys: []
            }));
            for (const areaId of areaIds) {
                const keyArr = areaId.split('-');

                for (const state of treeDataRef.current) {
                    const stateKey = keyArr[0];

                    if (stateKey && stateKey === state.key) {
                        const stateItem = state;
                        // if next children was null, define current children to current item
                        if (stateItem.children && stateItem.children.length === 0) {
                            const requestAreaId = keyArr[0];
                            const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
                            newHaveBeenRequestAreaIds.push(requestAreaId);
                            setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
                            const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
                            const administrativeArea = handleAreaFormat(res, stateKey);
                            stateItem.children = administrativeArea;
                            const include = localExpandKeys.includes(keyArr[0]);
                            include ? stateItem.icon = <SoilProfileExpandIcon /> : stateItem.icon = <SoilProfileDropDownIcon />;
                        }
                        const provinceKey = `${keyArr[0]}-${keyArr[1]}`;
                        for (const provinceItem of stateItem.children) {
                            if (provinceItem.key === provinceKey) {
                                const targetProvinceItem = provinceItem;
                                if (targetProvinceItem.children && targetProvinceItem.children.length === 0) {
                                    const requestAreaId = keyArr[1];
                                    const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
                                    newHaveBeenRequestAreaIds.push(requestAreaId);
                                    setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
                                    const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
                                    const administrativeArea = handleAreaFormat(res, provinceKey);
                                    targetProvinceItem.children = administrativeArea;
                                    if (provinceItem.item.area_IfHasChildLevel) {
                                        const include = localExpandKeys.includes(provinceKey);
                                        include ? targetProvinceItem.icon = <SoilProfileExpandIcon /> : targetProvinceItem.icon = <SoilProfileDropDownIcon />;
                                    } else {
                                        targetProvinceItem.icon = null;
                                    }
                                }
                                const cityKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}`;
                                for (const cityItem of targetProvinceItem.children) {
                                    if (cityItem.key === cityKey) {
                                        const targetCityItem = cityItem;
                                        if (targetCityItem.children && targetCityItem.children.length === 0) {
                                            const requestAreaId = keyArr[2];
                                            const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
                                            newHaveBeenRequestAreaIds.push(requestAreaId);
                                            setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
                                            const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
                                            const administrativeArea = handleAreaFormat(res, cityKey);
                                            if (targetCityItem.item.area_IfHasChildLevel) {
                                                const include = localExpandKeys.includes(cityKey);
                                                include ? targetCityItem.icon = <SoilProfileExpandIcon /> : targetCityItem.icon = <SoilProfileDropDownIcon />;
                                            } else {
                                                targetCityItem.icon = null;
                                            }
                                            targetCityItem.children = administrativeArea;
                                        }
                                        const districtKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}`;
                                        for (const district of targetCityItem.children) {
                                            if (district.key === districtKey) {
                                                const targetDistrictItem = district;
                                                if (targetDistrictItem.children && targetDistrictItem.children.length === 0) {
                                                    const requestAreaId = keyArr[3];
                                                    const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
                                                    newHaveBeenRequestAreaIds.push(requestAreaId);
                                                    setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
                                                    const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
                                                    const administrativeArea = handleAreaFormat(res, districtKey);
                                                    if (targetDistrictItem.item.area_IfHasChildLevel) {
                                                        const include = localExpandKeys.includes(districtKey);
                                                        include ? targetDistrictItem.icon = <SoilProfileExpandIcon /> : targetDistrictItem.icon = <SoilProfileDropDownIcon />;
                                                    } else {
                                                        targetCityItem.icon = null;
                                                    }
                                                    targetDistrictItem.children = administrativeArea;
                                                }
                                                const countyKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}`;
                                                for (const countyItem of targetDistrictItem.children) {
                                                    if (countyItem.key === countyKey) {
                                                        const targetCountyItem = countyItem;
                                                        const requestAreaId = keyArr[4];
                                                        const newHaveBeenRequestAreaIds = [...haveBeenRequestAreaIds];
                                                        newHaveBeenRequestAreaIds.push(requestAreaId);
                                                        setHaveBeenRequestAreaIds(newHaveBeenRequestAreaIds);
                                                        const res = await soilSearchGetAdministrativeArea(requestAreaId, false);
                                                        const administrativeArea = handleAreaFormat(res, countyKey);
                                                        if (targetCountyItem && targetCountyItem.length === 0) {
                                                            if (targetCountyItem.item.area_IfHasChildLevel) {
                                                                const include = localExpandKeys.includes(countyKey);
                                                                include ? targetCountyItem.icon = <SoilProfileExpandIcon /> : targetCountyItem.icon = <SoilProfileDropDownIcon />;
                                                            } else {
                                                                targetCityItem.icon = null;
                                                            }
                                                            targetCountyItem.children = administrativeArea;
                                                        }
                                                        const touwnKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}-${keyArr[5]}`;
                                                        for (const town of targetCountyItem.children) {
                                                            if (town.key === touwnKey){
                                                                const targetTown = town;
                                                                targetTown.children = administrativeArea;
                                                                targetTown.icon = null;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            setTreeData([...treeDataRef.current]);
            dispatch(updateThirdTabValues({
                expandedKeys: expandedKeysRef.current,
                checkedKeys: checkedKeysRef.current
            }));
            setIsFetching(false);
        } catch (err) {
            setIsFetching(false);
        }
    };

    const handleAreaFormat = (areaInfoList: ISoilSearchAdministrativeAreaResModel[], fatherAreaId: string): ITreeSingleMode[] => {
        const administrativeArea = areaInfoList.map((area): ITreeSingleMode => {
            return {
                title: area.area_Name,
                key: `${fatherAreaId}-${area.area_ID}`,
                item: area,
                children: [],
                icon: area.area_IfHasChildLevel ? <SoilProfileDropDownIcon /> : null
            };
        });
        return administrativeArea;
    };

    // SECTION: normal function
    const onSelect = (selectedKeys, event) => {
        const selectedKey = event.node.key;
        const newExpandKeys = [...expandedKeys];
        const areaId = selectedKeys[0];
        const haveBeenRequest = haveBeenRequestAreaIds.includes(selectedKey);

        if (expandedKeys.includes(selectedKey)) {
            const index = newExpandKeys.indexOf(selectedKey);
            const removeKeyArr = newExpandKeys.splice(index, 1);
            const targetKey = removeKeyArr[0];

            dispatch(updateThirdTabValues({ expandedKeys: newExpandKeys }));
            if (haveBeenRequest) {
                configMenu(targetKey, newExpandKeys);
                return;
            }
        } else {
            newExpandKeys.push(selectedKey);
            dispatch(updateThirdTabValues({ expandedKeys: newExpandKeys }));
            if (haveBeenRequest) {
                configMenu(selectedKey, newExpandKeys);
                return;
            }
        }
        if (areaId) {
            requestForNormalAreaInfo(areaId, newExpandKeys);
        }
    };

    const handleBackTreeData = async () => {
        if (fromQueryHistory && checkedKeys.length > 0) {
            requestForNormalAreaInfoForWriteBack(checkedKeys, expandedKeys);
        }
    };

    const configMenu = (areaId: string, localExpandKeys: string[]) => {
        const keyArr = areaId.split('-');
        for (const state of treeData) {
            const stateKey = keyArr[0];
            if (stateKey && stateKey === state.key) {
                const stateItem = state;
                // if next children was null, define current children to current item
                if (!keyArr[1]) {
                    if (stateItem.item.area_IfHasChildLevel) {
                        const include = localExpandKeys.includes(keyArr[0]);
                        include ? stateItem.icon = <SoilProfileExpandIcon /> : stateItem.icon = <SoilProfileDropDownIcon />;
                    } else {
                        stateItem.icon = null;
                    }
                    break;
                }
                const provinceKey = `${keyArr[0]}-${keyArr[1]}`;
                for (const provinceItem of stateItem.children) {
                    if (provinceItem.key === provinceKey) {
                        const targetProvinceItem = provinceItem;
                        if (!keyArr[2]) {
                            if (provinceItem.item.area_IfHasChildLevel) {
                                const include = localExpandKeys.includes(provinceKey);
                                include ? targetProvinceItem.icon = <SoilProfileExpandIcon /> : targetProvinceItem.icon = <SoilProfileDropDownIcon />;
                            } else {
                                targetProvinceItem.icon = null;
                            }
                            break;
                        }
                        const cityKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}`;
                        for (const cityItem of targetProvinceItem.children) {
                            if (cityItem.key === cityKey) {
                                const targetCityItem = cityItem;
                                if (!keyArr[3]) {
                                    if (targetCityItem.item.area_IfHasChildLevel) {
                                        const include = localExpandKeys.includes(cityKey);
                                        include ? targetCityItem.icon = <SoilProfileExpandIcon /> : targetCityItem.icon = <SoilProfileDropDownIcon />;
                                    } else {
                                        targetCityItem.icon = null;
                                    }
                                    break;
                                }
                                const districtKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}`;
                                for (const district of targetCityItem.children) {
                                    if (district.key === districtKey) {
                                        const targetDistrictItem = district;
                                        if (!keyArr[4]) {
                                            if (targetDistrictItem.item.area_IfHasChildLevel) {
                                                const include = localExpandKeys.includes(districtKey);
                                                include ? targetDistrictItem.icon = <SoilProfileExpandIcon /> : targetDistrictItem.icon = <SoilProfileDropDownIcon />;
                                            } else {
                                                targetDistrictItem.icon = null;
                                            }
                                            break;
                                        }
                                        const countyKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}`;
                                        for (const countyItem of targetDistrictItem.children) {
                                            if (countyItem.key === countyKey) {
                                                const targetCountyItem = countyItem;
                                                if (!keyArr[5]) {
                                                    if (targetCountyItem.item.area_IfHasChildLevel) {
                                                        const include = localExpandKeys.includes(countyKey);
                                                        include ? targetCountyItem.icon = <SoilProfileExpandIcon /> : targetCountyItem.icon = <SoilProfileDropDownIcon />;
                                                    } else {
                                                        targetCountyItem.icon = null;
                                                    }
                                                    break;
                                                }
                                                const touwnKey = `${keyArr[0]}-${keyArr[1]}-${keyArr[2]}-${keyArr[3]}-${keyArr[4]}-${keyArr[5]}`;
                                                for (const town of targetCountyItem.children) {
                                                    if (town.key === touwnKey){
                                                        const targetTown = town;
                                                        targetTown.icon = null;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        setTreeData([...treeData]);
    };

    const commomWarning = (message: string) => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: message,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const onCheck = (checkedKeys, checkedItems?) => {
        dispatch(updateThirdTabValues({
            checkedKeys,
            checkedNames: checkedItems.checkedNodes.map((item) => item.title)
        }));

        const selectedKeys = [];
        for (const key of checkedKeys) {
            const keyArr = key.split('-');
            if (keyArr.length === 1) {
                selectedKeys.push(key);
            }
        }

        for (const key of checkedKeys) {
            const keyArr = key.split('-');

            if (keyArr.length === 2) {
                let include = false;
                for (const selectedKey of selectedKeys) {
                    if (key.includes(selectedKey)) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    selectedKeys.push(keyArr[1]);
                }
            }
        }

        for (const key of checkedKeys) {
            const keyArr = key.split('-');
            if (keyArr.length === 3) {
                let include = false;
                for (const selectedKey of selectedKeys) {
                    if (key.includes(selectedKey)) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    selectedKeys.push(keyArr[2]);
                }
            }
        }

        for (const key of checkedKeys) {
            const keyArr = key.split('-');
            if (keyArr.length === 4) {
                let include = false;
                for (const selectedKey of selectedKeys) {
                    if (key.includes(selectedKey)) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    selectedKeys.push(keyArr[3]);
                }
            }
        }

        for (const key of checkedKeys) {
            const keyArr = key.split('-');
            if (keyArr.length === 5) {
                let include = false;
                for (const selectedKey of selectedKeys) {
                    if (key.includes(selectedKey)) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    selectedKeys.push(keyArr[4]);
                }
            }
        }

        for (const key of checkedKeys) {
            const keyArr = key.split('-');
            if (keyArr.length === 6) {
                let include = false;
                for (const selectedKey of selectedKeys) {
                    if (key.includes(selectedKey)) {
                        include = true;
                        break;
                    }
                }
                if (!include) {
                    selectedKeys.push(keyArr[5]);
                }
            }
        }

        dispatch(updateThirdTabValues({
            areaIds: selectedKeys
        }));
    };

    const handlePropertyListSelect = (record: GetPropertyListResponseModel) => {
        setSelectedProperty(record);
        let haveAdded = false;
        let chemicalAllTagAdded = false;
        let physicalAllTagAdded = false;
        adminiTabPropertySet.forEach((item) => {
            if (record.id === item.id) {
                haveAdded = true;
            }
            if (item.id === -10) {
                chemicalAllTagAdded = true;
            }
            if (item.id === -20) {
                physicalAllTagAdded = true;
            }
        });

        // duplicated selected item filter
        if (haveAdded) {
            return;
        }

        if ((record.category === 'Physical' && physicalAllTagAdded) || (record.category === 'Chemical' && chemicalAllTagAdded)) {
            return;
        }

        // normal selected handle method
        if (record.id === -10) {
            const newSelectedPropertySet = adminiTabPropertySet.filter((item) => item.category !== 'Chemical' || item.id === -20);
            dispatch(updateThirdTabValues({
                adminiTabPropertySet: [record, ...newSelectedPropertySet]
            }));
            return;
        }

        if (record.id === -20) {
            const newSelectedPropertySet = adminiTabPropertySet.filter((item) => item.category !== 'Physical' || item.id === -10);
            dispatch(updateThirdTabValues({
                adminiTabPropertySet: [record, ...newSelectedPropertySet]
            }));
            return;
        }

        const cachePropertySelectedList = [...adminiTabPropertySet];
        cachePropertySelectedList.push(record);
        dispatch(updateThirdTabValues({
            adminiTabPropertySet: cachePropertySelectedList
        }));
    };

    const handleRemoveProperty = (removeItem: GetPropertyListResponseModel) => {
        const removedProperty = [];
        adminiTabPropertySet.forEach((item: GetPropertyListResponseModel) => {
            if (item.id !== removeItem.id) {
                removedProperty.push(item);
            }
        });
        dispatch(updateThirdTabValues({
            adminiTabPropertySet: removedProperty
        }));
    };

    const handleExecuteButtonClick = () => {
        if (areaIds.length === 0) {
            return commomWarning('Please select area!!');
        }

        if (adminiTabPropertySet.length === 0) {
            return commomWarning('Please select property');
        }
        executeButtonClick();
    };

    const handleClearAllCondition = async () => {
        dispatch(updateThirdTabValues({
            expandedKeys: []
        }));
        dispatch(updateThirdTabValues({
            areaIds: [],
            adminiTabPropertySet: []
        }));
        dispatch(updateThirdTabValues({
            checkedKeys: [],
            checkedNames: []
        }));
    };

    return (
        <div className='soil-country-state-selected-container'>
            <div className='admin-div'>
                <span>Administrative areas</span>
            </div>
            <Spin spinning={isFetching}>
                <Tree
                    className='state-country-tree'
                    checkable
                    treeData={treeData}
                    onSelect={onSelect}
                    onCheck={onCheck}
                    expandedKeys={expandedKeys}
                    showLine={{showLeafIcon: false}}
                    checkedKeys={checkedKeys}
                    showIcon={true}
                    blockNode={true}
                    switcherIcon={<div style={{
                        height: '11px',
                        width: '23.15px',
                        display: 'flex',
                        justifyContent: 'center',
                        overflow: 'visible'
                    }}>
                        <div style={{
                            height: '30px' ,
                            width: '1px',
                            background: '#d9d9d9'
                        }} />
                        <div style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            height: '1px',
                            width: '10px',
                            background: '#d9d9d9'
                        }} />
                    </div>}
                />
            </Spin>
            <h4>Soil Properties</h4>
            <SoilSearchProperties
                dataSource={soilPropertyList}
                selectedText={selectedProperty && selectedProperty.name}
                selectTargetPropertiesCallback={(record) => handlePropertyListSelect(record)}
            />
            <div className='soil-properties-tag'>
                <div className='inner-div'>
                    {adminiTabPropertySet.map((item) => (
                        <div className='property-tag' key={item.id}>
                            <span className={item.category === 'Chemical' ?
                                'chemical-categoty-span' : 'physical-category-span'}>
                                {item.category}
                            </span>
                            {item.name}
                            <button onClick={() => handleRemoveProperty(item)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bottom-button-div'>
                <button className='clear-button' onClick={() => handleClearAllCondition()}>
                    Clear
                </button>
                <div>
                    <button
                        className='clear-button'
                        onClick={saveQueryButtonClick}
                    >
                    Save Query
                    </button>
                    <button
                        onClick={() => handleExecuteButtonClick()}
                        className='fill-soil-properties'>
                        { areaIds.length > 0 ? adminiTabPropertySet.length > 0 ? 'Execute' : 'Fill soil properties' : 'Fill areas' }
                    </button>
                </div>
            </div>
        </div>
    );
};


export default AdminAreaComponent;